import React from 'react';
import { translate } from '../../i18n';
import useBgColorStore from '../../store/bgColor';
import { generatePretravelLink } from '../../utils/generatePretravelLink';
import { IBookingDetail } from '../../type/bookingDetail';

type BookingGroup = {
  bookingItems: IBookingDetail[];
};

type Props = {
  bookings: BookingGroup[];
};

const ViewBookingDetailsCard: React.FC<Props> = ({ bookings }) => {
  const { bgColor, updateBgColor } = useBgColorStore();
  return (
    <div className="space-y-6">
      {bookings?.map((booking: any, index: number) => (
        <div
          key={`${booking?.bookingId}${index}`}
          className="bg-backgroundColor-white"
        >
          <div className="grid grid-cols-2 gap-y-2 text-sm text-textColorGray text-left">
            <div className="col-span-2">
              <p className="font-medium">
                {index === 0
                  ? translate('viewBookings.bkgId')
                  : translate('viewBookings.refNo')}
              </p>
              {index === 0 ? (
                <p className="font-semibold text-textBlack">
                  {booking?.bookingId}
                </p>
              ) : (
                <p>{booking?.refNo}</p>
              )}
            </div>
            {index === 0 ? (
              <div>
                <p className="font-medium">
                  {translate('viewBookings.Pretravel')}
                </p>
                <p>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: generatePretravelLink(booking),
                    }}
                  />
                </p>
              </div>
            ) : null}
            <div>
              <p className="font-medium">{translate('allocation.tour')}</p>
              <p>{booking?.tripName}</p>
            </div>
            {index === 0 ? (
              <div>
                <p className="font-medium">{translate('viewBookings.cxl')}</p>
                <p>{booking?.cxlSurveyStatus}</p>
              </div>
            ) : null}
            <div>
              <p className="font-medium">
                {translate('viewBookings.d1OpsChecklist')}
              </p>
              <p>{booking?.d1OpsNote ? booking?.d1OpsNote : '---'}</p>
            </div>
            <div>
              <p className="font-medium">{translate('allocation.Pickup')}</p>
              <p>{booking?.pickup}</p>
            </div>
            <div>
              <p className="font-medium">{translate('allocation.dropOff')}</p>
              <p>{booking?.dropoff}</p>
            </div>
            <div>
              <p className="font-medium">{translate('allocation.agent')}</p>
              <p>{booking?.agentName}</p>
            </div>
            {index === 0 ? (
              <>
                <div>
                  <p className="font-medium">
                    {translate('viewBookings.person')}
                  </p>
                  <p>{booking?.paxName}</p>
                </div>
                <div>
                  <p className="font-medium">
                    {translate('viewBookings.assoAgent')}
                  </p>
                  <p>{booking?.assocAgentName}</p>
                </div>
                <div>
                  <p className="font-medium">
                    {translate('viewBookings.marketSource')}
                  </p>
                  <p>{booking?.marketSource}</p>
                </div>
              </>
            ) : null}
          </div>

          <div className="grid grid-cols-3 gap-2 mt-4 text-left">
            <div
              className={`${bgColor} rounded-md p-2 flex flex-col items-center`}
            >
              <p className="font-medium text-textColorGray">
                {translate('viewBookings.male')}
              </p>
              <p className="text-textColorGray">{booking?.male}</p>
            </div>
            <div
              className={`${bgColor} rounded-md p-2 flex flex-col items-center`}
            >
              <p className="font-medium text-textColorGray">
                {translate('viewBookings.female')}
              </p>
              <p className="text-textColorGray">{booking?.female}</p>
            </div>
            <div
              className={`${bgColor} rounded-md p-2 flex flex-col items-center`}
            >
              <p className="font-medium text-textColorGray">
                {translate('viewBookings.child')}
              </p>
              <p className="text-textColorGray">{booking?.children}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ViewBookingDetailsCard;
